import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: '¡Hola!',
  ProductCode: 'spes43',
  Description:
    '<p>Here&#39;s all the online content included with your <strong>Spanish Complete Revision &amp; Practice</strong>.&nbsp;</p>\n',
  Credits:
    '<p><em>Proofreaders: Encarna Aparicio-Dominguez, Lara Falomir Dominguez, Gail Partington, Suzanne Rose </em></p>\n' +
    '\n' +
    '<p><em>Questions throughout are based on Pearson Edexcel type questions.</em></p>\n' +
    '\n' +
    '<p><em>Audio produced by Voice Talent Online.</em></p>\n' +
    '\n' +
    '<p><em>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2025. All rights reserved.</em></p>',
};
